import React, { useState } from "react";

import Callicon from "../images/call_icon.png";
import Emailicon from "../images/email_icon.png";
import Locationicon from "../images/maps-and-flags.png";
import Linkedinicon from "../images/linkedin_icon.png";
import Facebookicon from "../images/facebook_icon.png";
import Instagramicon from "../images/instagram_icon.png";
import Twittericon from "../images/twitter_icon.png";

const ContactForm = () => {
  // =========================
  // STATE
  // =========================
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    project: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  // =========================
  // HANDLERS
  // =========================
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");

    try {
      // 🔹 LOCAL (development)
      // const API_URL = "http://localhost:8000/api/submit.php";

      // 🔹 PRODUCTION (Hostinger)
      const API_URL = "https://www.hopewebsolution.com/api/submit.php";

      const res = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (data.success) {
        setSuccessMsg("Thank you! Your message has been sent.");
        setForm({ name: "", email: "", phone: "", project: "" });
      } else {
        setErrorMsg(data.message || "Something went wrong.");
      }
    } catch (err) {
      setErrorMsg("Server error. Please try again later.");
    }

    setLoading(false);
  };

  // =========================
  // JSX
  // =========================
  return (
    <section className="planning-section technology-section">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-8 mb-4 mb-lg-0 position-relative text-center">
            <span className="about-label">Get In Touch</span>
            <h2 className="title">Hey! Let’s Talk</h2>
          </div>
        </div>

        <div className="row mt-3 gy-4">
          {/* FORM */}
          <div className="col-lg-8 col-md-12 col-sm-12">
            <form className="contact-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                required
                value={form.name}
                onChange={handleChange}
              />

              <input
                type="email"
                name="email"
                placeholder="Email"
                required
                value={form.email}
                onChange={handleChange}
              />

              <input
                type="tel"
                name="phone"
                placeholder="Phone"
                required
                value={form.phone}
                onChange={handleChange}
              />

              <textarea
                rows="4"
                name="project"
                placeholder="Tell us about your project"
                required
                value={form.project}
                onChange={handleChange}
              />

              {/* STATUS */}
              {errorMsg && <p className="error-msg">{errorMsg}</p>}
              {successMsg && <p className="success-msg">{successMsg}</p>}

              <button className="btn btn-orange" type="submit" disabled={loading}>
                {loading ? "Sending..." : "Send Now"}
              </button>
            </form>
          </div>

          {/* CONTACT INFO */}
          <div className="col-lg-4 col-md-12 col-sm-12">
            <div className="contact-info">
              <div className="info-item">
                <span className="svg-icon">
                  <img src={Callicon} className="img-fluid" alt="Call Icon" />
                </span>
                <div>
                  <span className="info-label">Call Anytime</span>
                  <span className="info-text">+91 7821012121</span>
                </div>
              </div>

              <div className="info-item">
                <span className="svg-icon">
                  <img src={Emailicon} className="img-fluid" alt="Email Icon" />
                </span>
                <div>
                  <span className="info-label">Send Email</span>
                  <span className="info-text">radhe@hopewebsolution.com</span>
                </div>
              </div>

              <div className="info-item">
                <span className="svg-icon">
                  <img src={Locationicon} className="img-fluid" alt="Location Icon" />
                </span>
                <div>
                  <span className="info-label">Visit Us</span>
                  <span className="info-text">
                    Office No. 325, Third Floor, Krishna Square Subhash Nagar,
                    Shastri Nagar, Jaipur, Rajasthan 302016
                  </span>
                </div>
              </div>

              <div className="follow-us">Follow us</div>
              <div className="social-list">
                <a href="#"><img src={Linkedinicon} alt="Linkedin" /></a>
                <a href="#"><img src={Instagramicon} alt="Instagram" /></a>
                <a href="#"><img src={Facebookicon} alt="Facebook" /></a>
                <a href="#"><img src={Twittericon} alt="Twitter" /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
